// extracted by mini-css-extract-plugin
export default {"productGallery":"wK-z","inQuickShop":"xK-z"};